import { css } from 'emotion';

import { colors } from '@cobliteam/base-components/src/styles/colors';

const header = css`
  display: flex;
  align-items: center;
  padding: 15px 20px;
  background: ${colors.gray.lightest};

  > span {
    margin-left: 15px;
  }
`;

export default {
  header,
};
